import { ActivityLogModule } from "../types/activity-log.types";

export const ACTIVITY_LOG_MODULE_LABEL: Record<ActivityLogModule, string> = {
  [ActivityLogModule.WORK_ORDER]: "Work Order",
  [ActivityLogModule.ENQUIRY]: "Enquiry",
  [ActivityLogModule.QUOTATION]: "Quotation",
  [ActivityLogModule.MATERIAL_REQUEST]: "Material Request",
  [ActivityLogModule.PETTY_WORK]: "Petty Work",
  [ActivityLogModule.PURCHASE_ORDER]: "Purchase Order",
  [ActivityLogModule.PAYMENT]: "Payment",
  [ActivityLogModule.INVOICE]: "Invoice",
  [ActivityLogModule.AMC]: "AMC",
  [ActivityLogModule.AMC_VISIT]: "AMC Visit",
  [ActivityLogModule.LEAVE_APPLICATION]: "Leave Application",
  [ActivityLogModule.PAYMENT_EXPECTATION]: "Payment Expectation",
  [ActivityLogModule.PAYROLL_RUN]: "Payroll Run",
  [ActivityLogModule.SITE_VISIT]: "Site Visit",
  [ActivityLogModule.AUTH]: "Authentication",
  [ActivityLogModule.CLIENT_ADVANCE]: "Client Advance",
  [ActivityLogModule.EMPLOYEE_ADVANCE]: "Employee Advance",
  [ActivityLogModule.COMPLAINT_MATERIAL]: "Complaint Material",
  [ActivityLogModule.MATERIAL_IN_OUT]: "Material In/Out",
  [ActivityLogModule.TOOL_IN_OUT]: "Tool In/Out",
  [ActivityLogModule.ROLE]: "Role",
};

export const ACTIVITY_LOG_MODULE_COLOR: Record<ActivityLogModule, string> = {
  [ActivityLogModule.WORK_ORDER]: "primary",
  [ActivityLogModule.ENQUIRY]: "warning",
  [ActivityLogModule.QUOTATION]: "warning",
  [ActivityLogModule.SITE_VISIT]: "warning",
  [ActivityLogModule.MATERIAL_REQUEST]: "info",
  [ActivityLogModule.PETTY_WORK]: "info",
  [ActivityLogModule.PURCHASE_ORDER]: "info",
  [ActivityLogModule.AMC]: "info",
  [ActivityLogModule.AMC_VISIT]: "info",
  [ActivityLogModule.PAYMENT]: "success",
  [ActivityLogModule.INVOICE]: "success",
  [ActivityLogModule.PAYMENT_EXPECTATION]: "success",
  [ActivityLogModule.LEAVE_APPLICATION]: "secondary",
  [ActivityLogModule.PAYROLL_RUN]: "secondary",
  [ActivityLogModule.AUTH]: "danger",
  [ActivityLogModule.CLIENT_ADVANCE]: "success",
  [ActivityLogModule.EMPLOYEE_ADVANCE]: "success",
  [ActivityLogModule.COMPLAINT_MATERIAL]: "warning",
  [ActivityLogModule.MATERIAL_IN_OUT]: "info",
  [ActivityLogModule.TOOL_IN_OUT]: "info",
  [ActivityLogModule.ROLE]: "secondary",
};

export const ACTIVITY_LOG_SOURCE_ROUTE: Partial<
  Record<ActivityLogModule, string>
> = {
  [ActivityLogModule.WORK_ORDER]: "/work-orders",
  [ActivityLogModule.ENQUIRY]: "/enquiry-management/enquiries",
  [ActivityLogModule.QUOTATION]: "/quotations",
  [ActivityLogModule.SITE_VISIT]: "/enquiry-management/site-visits",
  [ActivityLogModule.MATERIAL_REQUEST]:
    "/inventory-management/material-requests",
  [ActivityLogModule.PETTY_WORK]: "/petty-works",
  [ActivityLogModule.PURCHASE_ORDER]: "/purchase-orders",
  [ActivityLogModule.AMC]: "/amc-management",
  [ActivityLogModule.AMC_VISIT]: "/amc-visits",
  [ActivityLogModule.PAYMENT]: "/payments",
  [ActivityLogModule.INVOICE]: "/invoices",
  [ActivityLogModule.LEAVE_APPLICATION]: "/hr-management/leave-applications",
  [ActivityLogModule.PAYROLL_RUN]: "/finance/payroll",
  [ActivityLogModule.COMPLAINT_MATERIAL]: "/complaint-materials",
};
